import type { PILOT_GPRS_CONSO_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/pilot-gprs-conso-card/pilot-gprs-conso-card.fr.ts";

export const PILOT_GPRS_CONSO_CARD_ENGLISH_LOCALE = {
  title: "GPRS Consumption",
  updated: "Updated { relativeDate }",
  alert: "Alert",
  alertDate: "At { date }",
} satisfies typeof PILOT_GPRS_CONSO_CARD_FRENCH_LOCALE;
